"use strict";

(function () {
    const form = document.getElementById("CostingPageForm");
    if (!form) return;

    const config = JSON.parse(form.dataset.config || "{}");

    const componentsEl       = document.getElementById("cp-components");
    const template           = document.getElementById("cp-component-template");
    const addBtn             = document.getElementById("cp-add-component");
    const saveBtn            = document.getElementById("cp-save");
    const resultInner        = document.getElementById("cp-result-inner");
    const componentsJSONEl   = document.getElementById("cp-components-json");
    const customerReferenceEl = document.getElementById("cp-customer-reference");
    const unitToggle         = document.getElementById("cp-unit-toggle");
    const typePicker         = document.getElementById("cp-type-picker");

    let rowCount = 0;

    // ── Helpers ──────────────────────────────────────────────────────────────

    function fmt(n) {
        return "£" + Math.round(Number(n) || 0).toLocaleString("en-GB");
    }

    function currentUnit() {
        const checked = unitToggle.querySelector('input[name="DimensionUnit"]:checked');
        return checked ? checked.value : "mm";
    }

    function getDimensionMM(row, axis) {
        if (currentUnit() === "mm") {
            return parseFloat(row.querySelector(`.cp-${axis}`).value) || 0;
        }
        const ft  = parseFloat(row.querySelector(`.cp-${axis}-ft`).value) || 0;
        const ins = parseFloat(row.querySelector(`.cp-${axis}-in`).value) || 0;
        return (ft * 12 + ins) * 25;
    }

    function formatImperial(mm) {
        const totalIn = mm / 25;
        const feet    = Math.floor(totalIn / 12);
        const inches  = Math.round(totalIn - feet * 12);
        return feet > 0 ? `${feet}' ${inches}"` : `${inches}"`;
    }

    // ── Unit mode ─────────────────────────────────────────────────────────────

    function applyUnitMode(row) {
        const isImperial = currentUnit() === "in";
        row.querySelectorAll(".cp-metric-wrap").forEach((el)  => { el.hidden = isImperial; });
        row.querySelectorAll(".cp-imperial-wrap").forEach((el) => { el.hidden = !isImperial; });
    }

    // ── Collapse / expand ─────────────────────────────────────────────────────

    const CHEVRON_DOWN = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    const CHEVRON_UP   = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>';

    function collapseRow(row) {
        const type    = row.querySelector(".cp-component-type").value || "";
        const shapeEl = row.querySelector(".cp-shape");
        const shape   = shapeEl.selectedIndex > 0 ? (shapeEl.options[shapeEl.selectedIndex]?.text || "") : "";
        const h = getDimensionMM(row, "height");
        const w = getDimensionMM(row, "width");
        const d = getDimensionMM(row, "depth");

        const parts = [type];
        if (shape) parts.push(shape);
        if (h > 0 && w > 0 && d > 0) {
            const dimStr = currentUnit() === "mm"
                ? `${Math.round(h)} × ${Math.round(w)} × ${Math.round(d)} mm`
                : `${formatImperial(h)} × ${formatImperial(w)} × ${formatImperial(d)}`;
            parts.push(dimStr);
        }
        row.querySelector(".cp-component-type-label").textContent = parts.join(" — ");
        row.querySelector(".cp-component-body").hidden = true;
        row.querySelector(".cp-collapse-component").innerHTML = CHEVRON_UP;
    }

    function expandRow(row) {
        row.querySelector(".cp-component-type-label").textContent = row.querySelector(".cp-component-type").value || "";
        row.querySelector(".cp-component-body").hidden = false;
        row.querySelector(".cp-collapse-component").innerHTML = CHEVRON_DOWN;
    }

    // ── Type picker ───────────────────────────────────────────────────────────

    const refWarning = document.getElementById("CostingPageForm").querySelector(".cp-ref-warning");

    function openPicker() {
        if (!customerReferenceEl.value.trim()) {
            refWarning.hidden = false;
            customerReferenceEl.focus();
            customerReferenceEl.classList.add("cp-field-error");
            return;
        }
        refWarning.hidden = true;
        customerReferenceEl.classList.remove("cp-field-error");

        const rows = Array.from(componentsEl.querySelectorAll(".costing-page__component"));
        const unfilledRows = rows.filter((row) => !rowIsFilled(row));
        if (unfilledRows.length > 0) {
            unfilledRows.forEach((row) => {
                expandRow(row);
                row.querySelector(".cp-component-warning").hidden = false;
            });
            unfilledRows[0].scrollIntoView({ behavior: "smooth", block: "nearest" });
            return;
        }

        rows.forEach(collapseRow);
        typePicker.hidden = false;
        typePicker.querySelector(".cp-type-picker__option").focus();
    }

    function closePicker() {
        typePicker.hidden = true;
    }

    typePicker.querySelectorAll(".cp-type-picker__option").forEach((btn) => {
        btn.addEventListener("click", () => {
            closePicker();
            addComponentRow(btn.dataset.type);
        });
    });

    document.getElementById("cp-type-picker-cancel").addEventListener("click", closePicker);
    typePicker.querySelector(".cp-type-picker__backdrop").addEventListener("click", closePicker);

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && !typePicker.hidden) closePicker();
    });

    // ── Flower holders ────────────────────────────────────────────────────────

    function setupFlowerHolders(row) {
        const componentType   = row.querySelector(".cp-component-type").value;
        const shapeID         = parseInt(row.querySelector(".cp-shape").value, 10);
        const shape           = (config.shapeRates && shapeID) ? config.shapeRates[shapeID] : null;
        const positions       = (shape && shape.flowerHolderPositions) ? shape.flowerHolderPositions : [];
        const flowerGroup     = row.querySelector(".costing-page__flower-holders");
        const flowerCheckboxes = row.querySelector(".costing-page__flower-checkboxes");

        flowerCheckboxes.innerHTML = "";

        if (componentType === "Headstone" || positions.length === 0) {
            flowerGroup.hidden = true;
            return;
        }

        positions.forEach((pos) => {
            const label = document.createElement("label");
            label.className = "costing-page__checkbox-label";
            const cb = document.createElement("input");
            cb.type = "checkbox";
            cb.className = "cp-flower-holder";
            cb.value = pos.title;
            cb.addEventListener("change", recalculateAll);
            label.appendChild(cb);
            label.appendChild(document.createTextNode(` ${pos.title} (+${fmt(config.containerHoleCharge || 0)} per unit)`));
            flowerCheckboxes.appendChild(label);
        });
        flowerGroup.hidden = false;
    }

    // ── Row management ────────────────────────────────────────────────────────

    function addComponentRow(componentType) {
        rowCount += 1;
        const fragment = template.content.cloneNode(true);
        const row = fragment.querySelector(".costing-page__component");
        row.dataset.index = rowCount;

        // Pre-set component type from picker selection
        row.querySelector(".cp-component-type").value = componentType;
        row.querySelector(".cp-component-type-label").textContent = componentType;

        row.querySelectorAll("select, input:not([type='hidden'])").forEach((el) => {
            el.addEventListener("input", () => { row.querySelector(".cp-component-warning").hidden = true; recalculateAll(); });
            el.addEventListener("change", () => { row.querySelector(".cp-component-warning").hidden = true; recalculateAll(); });
        });

        row.querySelector(".cp-shape").addEventListener("change", () => {
            setupFlowerHolders(row);
            recalculateAll();
        });

        row.querySelector(".cp-collapse-component").addEventListener("click", () => {
            const body = row.querySelector(".cp-component-body");
            if (body.hidden) { expandRow(row); } else { collapseRow(row); }
        });

        row.querySelector(".cp-remove-component").addEventListener("click", () => {
            row.remove();
            recalculateAll();
        });

        componentsEl.appendChild(row);
        applyUnitMode(row);
        recalculateAll();
    }

    // ── Validation ────────────────────────────────────────────────────────────

    function rowIsFilled(row) {
        return (
            Boolean(row.querySelector(".cp-component-type").value) &&
            Boolean(row.querySelector(".cp-shape").value) &&
            getDimensionMM(row, "height") > 0 &&
            getDimensionMM(row, "width")  > 0 &&
            getDimensionMM(row, "depth")  > 0 &&
            Boolean(row.querySelector(".cp-material").value) &&
            Boolean(row.querySelector(".cp-finish").value) &&
            parseInt(row.querySelector(".cp-qty").value, 10) > 0
        );
    }

    // ── Calculation ───────────────────────────────────────────────────────────

    function calculateRow(row) {
        const componentType = row.querySelector(".cp-component-type").value;
        const h             = Math.round(getDimensionMM(row, "height"));
        const w             = Math.round(getDimensionMM(row, "width"));
        const d             = Math.round(getDimensionMM(row, "depth"));
        const qty           = parseInt(row.querySelector(".cp-qty").value, 10);
        const shapeID       = parseInt(row.querySelector(".cp-shape").value, 10);
        const matID         = parseInt(row.querySelector(".cp-material").value, 10);
        const finish        = row.querySelector(".cp-finish").value;
        const marginID      = parseInt(row.querySelector(".cp-margin").value, 10) || 0;

        const shapeEl   = row.querySelector(".cp-shape");
        const matEl     = row.querySelector(".cp-material");
        const shapeName = shapeEl.options[shapeEl.selectedIndex]?.text || "";
        const matName   = matEl.options[matEl.selectedIndex]?.text   || "";

        const shape       = config.shapeRates[shapeID]    || { markupPct: 0, flowerHolderPositions: [] };
        const material    = config.materials[matID]        || { costPerM3: 0, discountPct: 0, eligible: false };
        const finishPct   = config.finishRates[finish]    || 0;
        const marginStyle = (config.marginStyles && marginID) ? config.marginStyles[marginID] : null;

        if (!material.eligible) {
            return { eligible: false, componentType, shapeName, matName, shapeID, matID, finish, qty, marginID };
        }

        const volumeM3        = (h / 1000) * (w / 1000) * (d / 1000);
        const materialCost    = volumeM3 * material.costPerM3;
        const shapeMarkupAmt  = materialCost * (shape.markupPct / 100);
        const finishMarkupAmt = materialCost * (finishPct / 100);
        const subtotal1       = materialCost + shapeMarkupAmt + finishMarkupAmt;
        const shippingAmt     = subtotal1 * (config.shippingPct / 100);
        const subtotal2       = subtotal1 + shippingAmt;

        let marginCharge = 0;
        let marginTitle  = "";
        if (marginStyle) {
            const perimetreM = ((h + w) * 2) / 1000;
            marginCharge = Math.max(perimetreM * marginStyle.costPerLinearMetre, marginStyle.minimumCharge);
            marginTitle  = marginStyle.title;
        }

        const selectedFlowerCBs      = Array.from(row.querySelectorAll(".cp-flower-holder:checked"));
        const selectedFlowerPositions = selectedFlowerCBs.map((cb) => cb.value);
        const flowerHolderCharge      = selectedFlowerCBs.length * (config.containerHoleCharge || 0);

        const unitPrice       = subtotal2 + marginCharge + flowerHolderCharge;
        const orderTotal      = unitPrice * qty;
        const discountedUnits = Math.floor(qty / 5) * 5;
        const discountAmt     = discountedUnits * unitPrice * (material.discountPct / 100);
        const totalPrice      = orderTotal - discountAmt;

        return {
            eligible: true,
            componentType, shapeName, matName,
            unitPrice, qty,
            marginCharge, marginTitle, marginID,
            flowerHolderCharge, selectedFlowerPositions,
            orderTotal,
            discountPct: material.discountPct, discountedUnits, discountAmt,
            totalPrice,
        };
    }

    // ── Render ────────────────────────────────────────────────────────────────

    function renderRowResult(row, r) {
        const el = row.querySelector(".costing-page__component-result");

        if (!r) {
            el.innerHTML = "";
            return;
        }

        if (!r.eligible) {
            el.innerHTML = `<p class="costing-page__row-note costing-page__row-note--request">This material needs a manual quote — we'll email you for full pricing.</p>`;
            return;
        }

        const marginRow = r.marginCharge > 0
            ? `<div class="costing-page__breakdown-row costing-page__breakdown-row--note">
                   <span>Modification (${r.marginTitle})</span>
                   <span>${fmt(r.marginCharge)} per unit</span>
               </div>` : "";

        const flowerHolderRow = r.flowerHolderCharge > 0
            ? `<div class="costing-page__breakdown-row costing-page__breakdown-row--note">
                   <span>Flower holder(s): ${r.selectedFlowerPositions.join(", ")}</span>
                   <span>${fmt(r.flowerHolderCharge)} per unit</span>
               </div>` : "";

        const discountRow = r.discountAmt > 0
            ? `<div class="costing-page__breakdown-row costing-page__breakdown-row--discount">
                   <span>Bulk discount (${r.discountPct}% off, qty in multiples of 5)</span>
                   <span>−${fmt(r.discountAmt)}</span>
               </div>` : "";

        el.innerHTML = `
            <div class="costing-page__breakdown">
                <div class="costing-page__breakdown-row costing-page__breakdown-row--unit">
                    <span>Unit price</span>
                    <span>${fmt(r.unitPrice)}</span>
                </div>
                ${marginRow}
                ${flowerHolderRow}
                <div class="costing-page__breakdown-row">
                    <span>Order total &times; ${r.qty}</span>
                    <span>${fmt(r.orderTotal)}</span>
                </div>
                ${discountRow}
                <div class="costing-page__breakdown-row costing-page__breakdown-row--total">
                    <span>Component total</span>
                    <span>${fmt(r.totalPrice)}</span>
                </div>
            </div>`;
    }

    function recalculateAll() {
        const rows = Array.from(componentsEl.querySelectorAll(".costing-page__component"));

        let allFilled     = true;
        let anyIneligible = false;
        let grandTotal    = 0;
        const summaries   = [];

        rows.forEach((row) => {
            if (!rowIsFilled(row)) {
                allFilled = false;
                renderRowResult(row, null);
                return;
            }
            const r = calculateRow(row);
            renderRowResult(row, r);
            if (!r.eligible) {
                anyIneligible = true;
            } else {
                grandTotal += r.totalPrice;
                summaries.push(r);
            }
        });

        if (!allFilled || rows.length === 0) {
            resultInner.classList.add("costing-page__result-inner--empty");
            resultInner.innerHTML = '<p class="costing-page__placeholder">Fill in all component fields to see a live price estimate.</p>';
            saveBtn.disabled = true;
            saveBtn.textContent = "Save & Generate Quote";
            return;
        }

        resultInner.classList.remove("costing-page__result-inner--empty");

        const hasCustomerReference = customerReferenceEl.value.trim().length > 0;
        const referenceNote = hasCustomerReference
            ? ""
            : `<p class="costing-page__row-note">Enter a Customer Reference above to save this quote.</p>`;

        if (anyIneligible) {
            resultInner.innerHTML = `
                <div class="costing-page__breakdown">
                    <h3>Live Estimate</h3>
                    <p class="costing-page__row-note costing-page__row-note--request">
                        One or more materials need a manual quote. Submitting will email your details to our team for full pricing.
                    </p>
                    ${referenceNote}
                </div>`;
            saveBtn.textContent = "Request a Quote";
        } else {
            resultInner.innerHTML = `
                <div class="costing-page__breakdown">
                    <h3>Live Estimate</h3>
                    <div class="costing-page__breakdown-row costing-page__breakdown-row--grand">
                        <span>Grand Total (Ex VAT)</span>
                        <span>${fmt(grandTotal)}</span>
                    </div>
                    <p class="costing-page__breakdown-note">Live estimate only &mdash; save to generate a formal reference number.</p>
                    ${referenceNote}
                </div>`;
            saveBtn.textContent = "Save & Generate Quote";
        }

        saveBtn.disabled = !hasCustomerReference;
    }

    // ── Events ────────────────────────────────────────────────────────────────

    customerReferenceEl.addEventListener("input", () => {
        if (customerReferenceEl.value.trim()) {
            refWarning.hidden = true;
            customerReferenceEl.classList.remove("cp-field-error");
        }
        recalculateAll();
    });

    addBtn.addEventListener("click", openPicker);

    unitToggle.addEventListener("change", () => {
        componentsEl.querySelectorAll(".costing-page__component").forEach(applyUnitMode);
        recalculateAll();
        fetch("/costing-page/save-unit", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: "unit=" + encodeURIComponent(currentUnit()) + "&SecurityID=" + encodeURIComponent(
                document.querySelector('input[name="SecurityID"]').value
            ),
        }).catch(() => {});
    });

    function formatDimensionsDisplay(row) {
        if (currentUnit() === "mm") {
            const h = Math.round(getDimensionMM(row, "height"));
            const w = Math.round(getDimensionMM(row, "width"));
            const d = Math.round(getDimensionMM(row, "depth"));
            return `${h} × ${w} × ${d} mm`;
        }
        const fmtImp = (ft, ins) => {
            const total  = ft * 12 + ins;
            const normFt = Math.floor(total / 12);
            const normIn = total % 12;
            return normFt > 0 ? `${normFt}'${normIn}"` : `${normIn}"`;
        };
        const hFt = parseInt(row.querySelector(".cp-height-ft").value, 10) || 0;
        const hIn = parseInt(row.querySelector(".cp-height-in").value,  10) || 0;
        const wFt = parseInt(row.querySelector(".cp-width-ft").value,  10) || 0;
        const wIn = parseInt(row.querySelector(".cp-width-in").value,   10) || 0;
        const dFt = parseInt(row.querySelector(".cp-depth-ft").value,  10) || 0;
        const dIn = parseInt(row.querySelector(".cp-depth-in").value,   10) || 0;
        return `${fmtImp(hFt, hIn)} × ${fmtImp(wFt, wIn)} × ${fmtImp(dFt, dIn)}`;
    }

    form.addEventListener("submit", () => {
        const rows = Array.from(componentsEl.querySelectorAll(".costing-page__component"));
        const payload = rows.map((row) => ({
            ComponentType:         row.querySelector(".cp-component-type").value,
            ShapeID:               row.querySelector(".cp-shape").value,
            Height:                Math.round(getDimensionMM(row, "height")),
            Width:                 Math.round(getDimensionMM(row, "width")),
            Depth:                 Math.round(getDimensionMM(row, "depth")),
            Unit:                  "mm",
            DimensionsDisplay:     formatDimensionsDisplay(row),
            MaterialID:            row.querySelector(".cp-material").value,
            Finish:                row.querySelector(".cp-finish").value,
            Quantity:              row.querySelector(".cp-qty").value,
            MarginStyleID:         row.querySelector(".cp-margin").value,
            FlowerHolderPositions: Array.from(row.querySelectorAll(".cp-flower-holder:checked"))
                                       .map((cb) => cb.value).join(","),
        }));
        componentsJSONEl.value = JSON.stringify(payload);
    });

    // ── Init ──────────────────────────────────────────────────────────────────

    recalculateAll();
})();
